import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
export var appointmentView = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(request_id) {
    var _res$data;
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = {
            request_id: request_id
          };
          _context.n = 1;
          return erpFetcher().get("/inspection-appointment/view?request_id=".concat(params.request_id));
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function appointmentView(_x) {
    return _ref.apply(this, arguments);
  };
}();